@if (loading) {
  <div *ngIf="loading" class="spinner-overlay">
    <p-progressSpinner class="spinner"></p-progressSpinner>
  </div>
}

<div class="team-matcher">
  <div class="team-matcher-content">
    <p>Seleziona il team per cui cercare i possibili membri:</p>
    <p-dropdown
      [(ngModel)]="selectedTeam"
      [options]="teams"
      placeholder="Seleziona team"
      [filter]="true"
      [disabled]="!teams.length"
      (onChange)="searchMatches(selectedTeam)"
      styleClass="w-full mb-3"
    ></p-dropdown>
    <div class="filter-checkbox-group">
      <label>
        <p-checkbox [(ngModel)]="showLike" binary="true"></p-checkbox>
        Mostra colonna L (Like)
      </label>
      <label>
        <p-checkbox [(ngModel)]="showTeachingLearning" binary="true"></p-checkbox>
        Mostra colonna F (Teaching/Learning)
      </label>
      <label>
        <p-checkbox
          [(ngModel)]="showUsersWithKnowledgeZero"
          binary="true"
          (onChange)="onShowUsersWithKnowledgeZeroChange()"
        ></p-checkbox>
        Mostra anche mismatch
      </label>
    </div>
  </div>

  <p-table
    *ngIf="skills.length && users.length"
    [value]="skills"
    scrollable="true"
    scrollHeight="600px"
    scrollDirection="both"
    class="w-full"
    [tableStyle]="{ 'margin-top': '1rem' }"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="sticky-skill" style="width:150px;">Skill</th>
        <ng-container *ngFor="let user of filteredUsers">
          <th
            [attr.colspan]="1 + (showLike ? 1 : 0) + (showTeachingLearning ? 1 : 0)"
            style="text-align: center;"
          >
            {{ user.acronym }}
          </th>
        </ng-container>
      </tr>
      <tr>
        <th class="sticky-skill"></th>
        <ng-container *ngFor="let user of filteredUsers">
          <th>K</th>
          <th *ngIf="showLike">L</th>
          <th *ngIf="showTeachingLearning">F</th>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-skill>
      <tr>
        <td class="sticky-skill">{{ skill }}</td>
        <ng-container *ngFor="let user of filteredUsers">
          <ng-container *ngIf="getRow(skill, user.acronym) as row; else emptyCells">
            <td
              [ngClass]="{'highlight-col': userToTeam[user.acronym.toLowerCase()] === selectedTeam}"
            >
              <div class="p-badge__wrap">
                <div class="p-badge p-badge-circle" [ngClass]="getColor('knowledge', row.knowledge)">
                  <i tooltipPosition="top" class="fa-solid" [ngClass]="getIcon('knowledge', row.knowledge)"></i>
                </div>
              </div>
            </td>
            <td *ngIf="showLike">
              <div class="p-badge__wrap">
                <div class="p-badge p-badge-circle" [ngClass]="getColor('like', row.like)">
                  <i tooltipPosition="top" class="fa-solid" [ngClass]="getIcon('like', row.like)"></i>
                </div>
              </div>
            </td>
            <td *ngIf="showTeachingLearning">
              <div class="p-badge__wrap">
                <div class="p-badge p-badge-circle" [ngClass]="getColor('teaching_learning', row.teaching_learning)">
                  <i tooltipPosition="top" class="fa-solid"
                     [ngClass]="getIcon('teaching_learning', row.teaching_learning)"></i>
                </div>
              </div>
            </td>
          </ng-container>
          <ng-template #emptyCells>
            <td></td>
            <td *ngIf="showLike"></td>
            <td *ngIf="showTeachingLearning"></td>
          </ng-template>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>

